import React from 'react';
import styled from '@emotion/styled';
import propTypes, { defaultProps } from './propTypes';
import {
  CardDate,
  CardTextContainer,
  FullWidthImageContainer,
  CardContainer,
  CardBodyText,
} from '../Card';
import Headline2 from '../Typography/Heading/Headline2';
import Label from '../Label';
import Labels from '../Card/Labels';
import breakpoints from '../Theme/breakpoints';

const StyledCardBodyText = styled(CardBodyText)`
  && {
    margin: 12px 0;

    @media (min-width: ${breakpoints.lg}px) {
      font-size: var(--size-body1);
      line-height: 1.8rem;
      color: var(--black-high);
    }
  }
`;

const StyledCardTextContainer = styled(CardTextContainer)`
  @media (min-width: ${breakpoints.sm}px) {
    text-align: center;
  }
`;

const BigCard = ({
  title,
  description,
  category,
  createdAt,
  image,
  labels,
  withPageMargins,
}) => (
  <CardContainer className="card-container">
    <FullWidthImageContainer withPageMargins={withPageMargins}>
      {image}
      <Label
        className="highlight"
      >
        {category}
        <Labels labels={labels} />
      </Label>
    </FullWidthImageContainer>
    <StyledCardTextContainer>
      <Headline2 tag="h2">
        {title}
      </Headline2>
      <StyledCardBodyText>
        {description}
      </StyledCardBodyText>
      {createdAt && (
        <CardDate>
          {createdAt}
        </CardDate>
      )}
    </StyledCardTextContainer>
  </CardContainer>
);

BigCard.defaultProps = defaultProps;

BigCard.propTypes = propTypes;

export default BigCard;
